import { useOpacityToggle } from '@amusnet/react-ui'
import React, { useRef } from 'react'
import { ChangeOpacityComponents } from 'game-ui-types'

interface SpinButtonSVGProps {
    text?: string
    fontSize?: number
}

const SpinButtonSVG: React.FC<SpinButtonSVGProps> = ({ text = '', fontSize = 20 }) => {
    const spinButtonText = useRef<SVGTextElement | null>(null)

    useOpacityToggle(ChangeOpacityComponents.SPIN_BUTTON_TEXT, spinButtonText)

    return (
        <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Spin-buttons/button-spin-big-enabled">
                <circle
                    id="Oval_Border"
                    cx="100"
                    cy="100"
                    r="97"
                    fill="black"
                    stroke="url(#paint0_linear)"
                    strokeWidth="6"
                />
                <circle id="Oval_Fill" cx="100" cy="100" r="91.5" fill="url(#paint1_linear)" stroke="#464646" />
                <g id="Arrows">
                    <path
                        id="Union"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M158.524 99.8003C158.608 99.6381 158.652 99.4531 158.645 99.2573C157.506 67.4452 131.633 42 99.8794 42C85.1614 42 71.0073 47.5892 60.2368 57.6151C59.8237 58.0012 59.7678 58.6446 60.1084 59.1034L70.6221 73.247C71.0185 73.7786 71.7834 73.8569 72.2692 73.4093C79.5333 66.6675 90.086 61.8168 99.885 61.8168C120.901 61.9175 137.992 78.5174 139.025 99.3357C139.033 99.5023 139.076 99.6598 139.147 99.8003H127.849C125.99 99.8003 124.946 101.943 126.085 103.415L126.079 103.409L146.844 130.158C147.732 131.305 149.457 131.31 150.356 130.175L171.512 103.426C172.673 101.96 171.629 99.8003 169.764 99.8003H158.524Z"
                        fill="white"
                    />
                    <path
                        id="Union_2"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M54.1956 69.7634L74.9158 96.5458C76.0548 98.0172 75.0051 100.154 73.1459 100.154L61.8398 100.136C61.9115 100.277 61.9551 100.435 61.9629 100.603C62.9623 121.421 80.0254 138.049 101.041 138.183C110.84 138.2 121.404 133.366 128.68 126.635C129.165 126.188 129.936 126.266 130.327 126.798L140.812 140.958C141.147 141.417 141.097 142.06 140.678 142.446C129.891 152.455 115.726 158.022 101.008 158C69.2549 157.95 43.4258 132.46 42.3426 100.647C42.3357 100.452 42.38 100.267 42.4632 100.105L31.2309 100.087C29.366 100.082 28.3275 97.9221 29.4889 96.4562L50.6836 69.741C51.5826 68.6052 53.3079 68.6164 54.1956 69.7634Z"
                        fill="white"
                    />
                </g>
                {/* Dynamic Text */}
                <text ref={spinButtonText}>
                    <textPath xlinkHref="#text-circle" startOffset="50%" textAnchor="middle">
                        <tspan id="turbo-spin" className="st0">
                            {text}
                        </tspan>
                    </textPath>
                </text>
            </g>
            <defs>
                <style>
                    {`
          .st0 {
            fill: #fff;
            font-family: Roboto-Bold, Roboto;
            font-size: ${fontSize}px;
            font-weight: 700;
          }
          `}
                </style>
                <path id="text-circle" d="M 100 176 a 75 75 90 0 1 0 -150 a 75 75 90 0 1 0 150 Z" />
                <linearGradient id="paint0_linear" x1="100" y1="0" x2="100" y2="200" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FCF1BD" />
                    <stop offset="0.22" stopColor="#E5BC53" />
                    <stop offset="0.475" stopColor="#F5DF96" />
                    <stop offset="0.76" stopColor="#B8A050" />
                    <stop offset="1" stopColor="#8A6D28" />
                </linearGradient>
                <linearGradient id="paint1_linear" x1="100" y1="8" x2="100" y2="192" gradientUnits="userSpaceOnUse">
                    <stop offset="0.05" stopColor="#555555" />
                    <stop offset="0.565" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default SpinButtonSVG
